import { render } from "./detailsModal.vue?vue&type=template&id=99576ba6&scoped=true&ts=true"
import script from "./detailsModal.vue?vue&type=script&lang=ts"
export * from "./detailsModal.vue?vue&type=script&lang=ts"

import "./detailsModal.vue?vue&type=style&index=0&id=99576ba6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99576ba6"]])

export default __exports__